import OT from '@opentok/client';
import { environment } from 'environments';

class TokboxPhoneCallController {
  constructor($rootScope, $scope, $timeout, toastr, ngDialog, Notifications, VideoService, Services) {
    'ngInject';

    Object.assign(this, {
      $rootScope,
      $scope,
      $timeout,
      toastr,
      ngDialog,
      Notifications,
      VideoService,
      Services,
      patient: $scope.ngDialogData.patient,
      visit: $scope.ngDialogData.visit,
      pharmacy: $scope.ngDialogData.pharmacy,
      status: "",
      phone_number: "",
      // hangup_by_doctor: false,
      // session: null,
      publisher: null,
      call: null
    });
    $rootScope.hangup_by_doctor = false;
    $rootScope.session = null;

    if (_.isEmpty(this.patient) && _.isEmpty(this.pharmacy)) {
      this.phone_number = "";
    } else if (this.patient && _.isEmpty(this.pharmacy)) {
      this.phone_number = this.patient.cell;
      if (this.phone_number.length && this.phone_number.substring(0, 1) == '0') this.phone_number = this.phone_number.substring(1);
    } else if (_.isEmpty(this.patient) && this.pharmacy) {
      this.phone_number = this.pharmacy.cell;
      if (this.phone_number.length && this.phone_number.substring(0, 1) == '0') this.phone_number = this.phone_number.substring(1);
    } // We do this to make the modal "movable or draggable"

    $scope.$on('ngDialog.opened', function () {
      $(".ngdialog-theme-default.tokbox-phonecall-modal").children(".ngdialog-content").draggable({
        handle: ".tokbox-phonecall-popup"
      });
    });
    this.createPhoneCallSession();
  }

  dialPhoneNumberDisplay() {
    return this.this.Services.dialPhoneNumberDisplay(this.phone_number, '(xxx) xxx-xxxx');
  }

  clickDialpad(digit) {
    if (!digit) return;

    if (digit == 'backspace') {
      if (this.phone_number.length) this.phone_number = this.phone_number.substring(0, this.phone_number.length - 1);
    } else {
      this.phone_number = this.phone_number + digit;
    }
  }

  finalizeCall() {
    try {
      this.$rootScope.session.disconnect();
      this.$rootScope.session = null;
    } catch (err) {
      console.log('Error disconnecting session (session.disconnect):', err);
    }

    this.$scope.closeThisDialog(false);
  }

  hangup() {
    if (!this.call || !this.call.id || !this.call.sip_call_id) {
      this.finalizeCall();
    } else {
      this.VideoService.hangupPhoneCall(this.call.id).then(({
        data
      }) => {
        console.log("this.VideoService.hangupPhoneCall()", data);
        this.finalizeCall();
      }).catch(err => {
        console.log('Error hanging up phone call (this.VideoService.hangupPhoneCall):', err);
        this.finalizeCall();
      });
    }
  }

  hangupByDoctor() {
    this.$rootScope.hangup_by_doctor = true;
    this.hangup();
  }

  dial() {
    if (!this.phone_number) {
      this.toastr.warning('Please enter phone number.');
      return;
    } // if (this.phone_number.length != 10) {
    //   this.toastr.warning('Phone number must have 10 digits.');
    //   return;
    // }


    if (!this.call || !this.call.id) return; // THIS FLAG IS TO CONTROL DOUBLE CLICK
    // WE MAKE SURE DOCTOR SENDS ONE CLICK (ONE DIAL) ONLY BETWEEN 2 SECONDS

    this.$timeout(() => {
      this.temp_disable_dial = false;
    }, 2000);
    if (this.temp_disable_dial) return;
    this.temp_disable_dial = true; // this.VideoService.makePhoneCall(this.call.id, "1" + this.phone_number)

    this.VideoService.makePhoneCall(this.call.id, "44" + this.phone_number).then(({
      data
    }) => {
      console.log("this.VideoService.makePhoneCall()", data);
      this.call = data;
    }).catch(err => {
      console.log('Error dialing phone number (this.VideoService.makePhoneCall):', err);
    });
  }

  createPhoneCallSession() {
    this.VideoService.createPhoneCallSession(this.visit.id).then(({
      data
    }) => {
      console.log("this.VideoService.createPhoneCallSession()", data);
      this.call = data;

      this.$rootScope.session = OT.initSession(environment.constants.TOKBOX_API_KEY, this.call.session_id);
      console.log("session:", this.$rootScope.session);
      this.publisher = OT.initPublisher('publisher');
      console.log("publisher:", this.publisher);
      this.$rootScope.session.on({
        streamCreated: event => {
          console.log(`Stream ${event.stream.name} created.`);
          const subscriberClassName = `subscriber-${event.stream.streamId}`;
          const subscriber = document.createElement('div');
          subscriber.setAttribute('id', subscriberClassName);
          document.getElementById('subscribers').appendChild(subscriber);
          this.$rootScope.session.subscribe(event.stream, subscriberClassName);
          this.status = 'ON-CALL'; // WE INITIALIZE THE FLAG WHEN WE START THE CALL

          this.$rootScope.hangup_by_doctor = false;
        },
        streamDestroyed: event => {
          console.log(`Stream ${event.stream.name} ended because ${event.reason}.`);

          if (!this.$rootScope.hangup_by_doctor) {
            this.toastr.warning('Looks like the patient hangup.');
            this.hangup();
          } // WE RESET THE FLAG AFTER THE CALL IS DONE


          this.$rootScope.hangup_by_doctor = false;
        },
        sessionConnected: event => {
          console.log('Session connected', event);
          this.$rootScope.session.publish(this.publisher);
          this.status = "READY-TO-CALL";
          this.$scope.$apply();
        }
      });
      this.$rootScope.session.connect(this.call.session_token, err => {
        if (err) {
          console.log('Error connecting to phone call session (session.connect):', err);
        }
      });
    }).catch(err => {
      console.log("Error creating phone call session (this.VideoService.createPhoneCallSession):", err);
    });
  }

}

TokboxPhoneCallController.$inject = ["$rootScope", "$scope", "$timeout", "toastr", "ngDialog", "Notifications", "VideoService", "Services"];
angular.module('pims').controller('TokboxPhoneCallController', TokboxPhoneCallController);
